import React, { createContext, useContext, useMemo, useState } from "react";

interface AuthContextValue {
  user: any;
  login: (e: any, t: any) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextValue>({
  user: null,
  login: (e, t) => {},
  logout: () => {},
});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }: any) => {
  const [user, setUser] = useState(null);

  const login = (user: any, token = null) => {
    if (token) {
      localStorage.setItem("authToken", token);
    } else {
    }
    setUser(user);
  };

  const logout = () => {
    localStorage.removeItem("authToken");
    setUser(null);
  };

  const contextValue = useMemo<AuthContextValue>(
    () => ({
      user,
      login,
      logout,
    }),
    [user]
  );

  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
};
